import { render, staticRenderFns } from "./TrucksListSkeleton.vue?vue&type=template&id=6de87830&scoped=true"
import script from "./TrucksListSkeleton.vue?vue&type=script&lang=js"
export * from "./TrucksListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TrucksListSkeleton.vue?vue&type=style&index=0&id=6de87830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de87830",
  null
  
)

export default component.exports